module.exports = __webpack_public_path__ + "static/media/demo-12.dbd9c1e9.jpg";